import React from 'react';
import { FormattedMessage } from 'react-intl';

import Localizable from 'lib/intl/localizable';
import Styled from 'styled';
import ScrollView from 'lib/scroll/scroll-view';

import BazaarProfilePureView from 'four-nets/bazaar/profile/bazaar-profile-pure-view';
import Modal from 'four-nets/ui-v2/modal/modal';

import { Props as BazaarProfilePureViewProps } from 'four-nets/bazaar/profile/bazaar-profile-pure-view';
import { User } from 'four-nets/user/user';

import ReviewTypeBarView from './review-type-bar-view';
import ReviewsLoader from './reviews-loader';

import defaultStyles from './reviews-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    user?: User | { username: string };
    onClose: () => void;
    open: boolean;
    fromSellers: boolean;
}

interface State {
    page: number;
}

@Localizable()
class ReviewsView extends React.Component<BazaarProfilePureViewProps & Props, State> {
    state = {
        page: 0,
    };

    onClose = () => {
        this.props.onClose();
    };

    changeType = (fromSellers: boolean) => {
        this.props.changeType(fromSellers);
    };

    changePage = (event: any, page: number) => {
        this.setState({ page });
    };

    render() {
        const { styles, open, ...rest } = this.props;

        return (
            <Modal
                title={<FormattedMessage id='REVIEWS_OF_THE_SELLER' values={{ gender: 'm' }} />}
                open={open}
                onClose={this.onClose}
            >
                <div className={styles.wrapper}>
                    <BazaarProfilePureView {...rest} />
                    <ReviewTypeBarView fromSellers={this.props.fromSellers} changeType={this.changeType} />
                    <ScrollView>
                        <ReviewsLoader
                            fromSellers={this.props.fromSellers}
                            page={this.state.page}
                            onPage={this.changePage}
                            user={this.props.user}
                        />
                    </ScrollView>
                </div>
            </Modal>
        );
    }
}

export default Styled(defaultStyles)(ReviewsView);
